import { theme } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectAssetGroups } from 'reduxStore/assetGroups/selectors';
import DeviceGroupsDrawer from 'zComponents/molecules/DeviceGroupDrawer';
import { Button, Col, Empty, Flex, Row, Typography } from 'zui/Antd';

const { Text } = Typography;

function RenderDeviceGroupsPanelContent({ searchResults = [], isSearching = false }) {
	const {
		token: {
			colorTextLabel,
			fontWeightStrong,
			padding,
			borderRadius,
			paddingSM,
			colorFill,
			colorPrimaryText,
			lineHeight,
			lineHeightLG,
			fontSizeLG
		}
	} = theme.useToken();

	const allDeviceGroupsData = useSelector(selectAssetGroups);

	const [openDrawer, setOpenDrawer] = useState(false);
	const [selectedGroup, setSelectedGroup] = useState(null);
	const displayData = isSearching ? searchResults.map((result) => result.item) : allDeviceGroupsData;

	if (displayData.length === 0) {
		return (
			<Flex align='center' justify='center' vertical style={{ width: '100%', padding }}>
				<Empty description={isSearching ? 'No search results found' : 'No device groups to display'} />
			</Flex>
		);
	}

	return (
		<Row gutter={[20, 20]} justify='start'>
			{displayData.map((deviceGroup, index) => (
				<Col key={isSearching ? `search-${index}` : index} xl={8} lg={12} sm={24}>
					<Flex
						vertical
						style={{
							border: `1px solid ${colorFill}`,
							padding: paddingSM,
							borderRadius,
							boxSizing: 'border-box'
						}}
					>
						<Flex align='center' justify='space-between'>
							<Flex vertical flex={1} style={{ width: 0 }}>
								<Text
									ellipsis={{ tooltip: deviceGroup?.name }}
									style={{
										width: '100%',
										color: colorTextLabel,
										fontWeight: fontWeightStrong,
										fontSize: fontSizeLG,
										lineHeight: lineHeightLG
									}}
								>
									{deviceGroup?.name || '--'}
								</Text>
								<Text
									ellipsis={{ tooltip: `Devices: ${deviceGroup?.devices?.length ?? '0'}` }}
									style={{
										width: '100%',
										color: colorTextLabel,
										fontWeight: 500,
										lineHeight: lineHeight
									}}
								>
									Devices: {deviceGroup?.devices?.length ?? '0'}
								</Text>
							</Flex>
							<Button
								onClick={() => {
									setSelectedGroup(deviceGroup?.groupID);
									setOpenDrawer(true);
								}}
								type='text'
								style={{ color: colorPrimaryText }}
							>
								View Device Group
							</Button>
						</Flex>
					</Flex>
				</Col>
			))}
			<DeviceGroupsDrawer groupID={selectedGroup} visible={openDrawer} setVisible={setOpenDrawer} />
		</Row>
	);
}

export default RenderDeviceGroupsPanelContent;
